import type { Tag } from '@/shared/types'

export type TagWithColor = Tag & { color: string }

export const getAvailableTagsWithColor = (tags: Tag[]): TagWithColor[] => {
	return (
		tags?.map((tag, i) => ({
			...tag,
			label: tag.name,
			value: tag._id,
			color: [
				'#a2293fff',
				'#bd752cff',
				'#d1b33cff',
				'#7da54dff',
				'#38b8a9ff',
				'#4688c2ff',
				'#7669a9ff',
				'#a252b0ff',
				'#C9C9C9',
			][i],
		})) ?? []
	)
}

export const getAvailableTagsObjWithColor = (tags: TagWithColor[]) => {
	return getAvailableTagsWithColor(tags).reduce<Record<string, Tag>>(
		(acc, tag) => {
			acc[tag._id] = tag
			return acc
		},
		{}
	)
}
